import { AdminLayout } from "@/views/layouts/AppLayout";
import { NotificationPage } from "@/views/pages/userOperation/notification/NotificationPage";
import { NotificationDetailPage } from "@/views/pages/userOperation/notification/NotificationDetailPage";
import { NotificationFormPage } from "@/views/pages/userOperation/notification/NotificationFormPage";
import { AdPageManagementPage } from "@/views/pages/userOperation/adPageManagement/AdPageManagementPage";
import { AdPageDetailPage } from "@/views/pages/userOperation/adPageManagement/AdPageDetailPage";
import { AdPageFormPage } from "@/views/pages/userOperation/adPageManagement/AdPageFormPage";
import { PopUpAdvertPage } from "@/views/pages/userOperation/popUpAdvert/PopUpAdvertPage";
import { PopUpAdvertDetailPage } from "@/views/pages/userOperation/popUpAdvert/PopUpAdvertDetailPage";
import { PopUpAdvertFormPage } from "@/views/pages/userOperation/popUpAdvert/PopUpAdvertFormPage";
import { SearchFoundPage } from "@/views/pages/userOperation/searchFound/SearchFoundPage";
import { AppVersionPage } from "@/views/pages/userOperation/appVersion/AppVersionPage";
import { BannerPage } from "@/views/pages/userOperation/adBanner/BannerPage";
import { AdvertisementPage } from "@/views/pages/userOperation/adBanner/AdvertisementPage";
import { AdvertisementFormPage } from "@/views/pages/userOperation/adBanner/AdvertisementFormPage";
import { AdvertisementTwoFormPage } from "@/views/pages/userOperation/adBanner/AdvertisementTwoFormPage";
import { LianYunArticlePage } from "@/views/pages/userOperation/lianYunAbout/LianYunArticlePage";
import { SampleApplyPage } from "@/views/pages/userOperation/sampleApply/SampleApplyPage";
import { SampleApplyDetailPage } from "@/views/pages/userOperation/sampleApply/SampleApplyDetailPage";
import { FundingCluesPage } from "@/views/pages/userOperation/fundingClues/FundingCluesPage";
import { FundingCluesDetailPage } from "@/views/pages/userOperation/fundingClues/FundingCluesDetailPage";
import { MessageFeedbackPage } from "@/views/pages/userOperation/messageFeedback/MessageFeedbackPage";
import { MessageFeedbackDetailPage } from "@/views/pages/userOperation/messageFeedback/MessageFeedbackDetailPage";
import { HelpCenterPage } from "@/views/pages/userOperation/helpCenter/HelpCenterPage";
import { HelpCenterDetailPage } from "@/views/pages/userOperation/helpCenter/HelpCenterDetailPage";
import { HelpCenterFormPage } from "@/views/pages/userOperation/helpCenter/HelpCenterFormPage";
import type { AdminRouteObject } from "../index";

/** 用户运营路由，先迁移平台通知并保留 Vue 的隐藏表单与详情入口。 */
export const userOperationRoutes: AdminRouteObject = {
    path: "/userOperation",
    element: <AdminLayout />,
    handle: { title: "用户运营" },
    children: [
        {
            path: "sampleApply",
            element: <SampleApplyPage />,
            handle: {
                title: "用户申请寄样",
                permissions: ["ROLE_APPLY_SAMPLE_R", "ROLE_APPLY_SAMPLE_DEAL"]
            }
        },
        {
            path: "sampleApply/detail",
            element: <SampleApplyDetailPage />,
            handle: {
                title: "用户申请寄样详情",
                permissions: ["ROLE_APPLY_SAMPLE_R", "ROLE_APPLY_SAMPLE_DEAL"]
            }
        },
        {
            path: "fundingClues",
            element: <FundingCluesPage />,
            handle: { title: "用户申请资金", permissions: ["ROLE_FUNDS_R", "ROLE_FUNDS_W"] }
        },
        {
            path: "fundingClues/detail",
            element: <FundingCluesDetailPage />,
            handle: { title: "用户申请资金详情", permissions: ["ROLE_FUNDS_R", "ROLE_FUNDS_W"] }
        },
        {
            path: "messageFeedback",
            element: <MessageFeedbackPage />,
            handle: { title: "用户留言反馈", permissions: ["ROLE_SS_FEEDBACK_R", "ROLE_SS_FEEDBACK_W"] }
        },
        {
            path: "messageFeedback/details",
            element: <MessageFeedbackDetailPage />,
            handle: { title: "用户留言详情", permissions: ["ROLE_SS_FEEDBACK_R", "ROLE_SS_FEEDBACK_W"] }
        },
        {
            path: "notificationManage",
            element: <NotificationPage />,
            handle: {
                title: "平台通知",
                permissions: ["ROLE_SS_NOTICE_R", "ROLE_SS_NOTICE_W"]
            }
        },
        {
            path: "notificationAdd",
            element: <NotificationFormPage />,
            handle: {
                title: "新增通知",
                permissions: ["ROLE_SS_NOTICE_R", "ROLE_SS_NOTICE_W"]
            }
        },
        {
            path: "NotificationEdit",
            element: <NotificationFormPage />,
            handle: {
                title: "编辑通知",
                permissions: ["ROLE_SS_NOTICE_R", "ROLE_SS_NOTICE_W"]
            }
        },
        {
            path: "notificationInfo",
            element: <NotificationDetailPage />,
            handle: { title: "通知详情", permissions: ["ROLE_SS_NOTICE_R", "ROLE_SS_NOTICE_W"] }
        },
        {
            path: "adPageManage",
            element: <AdPageManagementPage />,
            handle: { title: "广告页管理", permissions: ["ROLE_SS_AD_LIST_R", "ROLE_SS_AD_LIST_W"] }
        },
        {
            path: "adPageManage/detail",
            element: <AdPageDetailPage />,
            handle: { title: "广告页详情", permissions: ["ROLE_SS_AD_LIST_R", "ROLE_SS_AD_LIST_W"] }
        },
        {
            path: "addAd",
            element: <AdPageFormPage />,
            handle: { title: "新增广告页", permissions: ["ROLE_SS_AD_LIST_R", "ROLE_SS_AD_LIST_W"] }
        },
        {
            path: "adPageManage/edit",
            element: <AdPageFormPage />,
            handle: { title: "编辑广告页", permissions: ["ROLE_SS_AD_LIST_R", "ROLE_SS_AD_LIST_W"] }
        },
        {
            path: "popUpAdvert",
            element: <PopUpAdvertPage />,
            handle: { title: "弹窗广告", permissions: ["ROLE_SS_POPUP_R", "ROLE_SS_POPUP_W"] }
        },
        {
            path: "popUpAdvert/detail",
            element: <PopUpAdvertDetailPage />,
            handle: { title: "弹窗广告详情", permissions: ["ROLE_SS_POPUP_R", "ROLE_SS_POPUP_W"] }
        },
        {
            path: "popUpAdvert/add",
            element: <PopUpAdvertFormPage />,
            handle: { title: "新增弹窗广告", permissions: ["ROLE_SS_POPUP_W"] }
        },
        {
            path: "popUpAdvert/edit",
            element: <PopUpAdvertFormPage />,
            handle: { title: "编辑弹窗广告", permissions: ["ROLE_SS_POPUP_W"] }
        },
        {
            path: "searchFound",
            element: <SearchFoundPage />,
            handle: { title: "搜索发现配置", permissions: ["ROLE_SEARCH_R", "ROLE_SEARCH_W"] }
        },
        {
            path: "appVersion",
            element: <AppVersionPage />,
            handle: { title: "APP版本管理", permissions: ["ROLE_SS_VERSION"] }
        },
        {
            path: "adBanner/banner",
            element: <BannerPage />,
            handle: { title: "移动端", permissions: ["ROLE_SS_AD_R", "ROLE_SS_AD_W"] }
        },
        {
            path: "adBanner/ad",
            element: <AdvertisementPage />,
            handle: { title: "PC端-首页广告位", permissions: ["ROLE_SS_AD_R", "ROLE_SS_AD_W"] }
        },
        {
            path: "adBanner/adEdit",
            element: <AdvertisementFormPage />,
            handle: { title: "修改广告位", permissions: ["ROLE_SS_AD_W"] }
        },
        {
            path: "adBanner/twoEditType",
            element: <AdvertisementTwoFormPage />,
            handle: { title: "修改广告位", permissions: ["ROLE_SS_AD_W"] }
        },
        {
            path: "lianYunAbout/aboutUs",
            element: <LianYunArticlePage articleType={1} />,
            handle: { title: "关于我们", permissions: ["ROLE_SS_ABOUT"] }
        },
        {
            path: "lianYunAbout/helpCenter",
            element: <HelpCenterPage />,
            handle: { title: "帮助中心", permissions: ["ROLE_SS_HELP_R", "ROLE_SS_HELP_W"] }
        },
        {
            path: "lianYunAbout/helpCenter/info",
            element: <HelpCenterDetailPage />,
            handle: { title: "常见问题详情", permissions: ["ROLE_SS_HELP_R", "ROLE_SS_HELP_W"] }
        },
        {
            path: "lianYunAbout/helpCenter/add",
            element: <HelpCenterFormPage />,
            handle: { title: "新增常见问题", permissions: ["ROLE_SS_HELP_R", "ROLE_SS_HELP_W"] }
        },
        {
            path: "lianYunAbout/helpCenter/edit",
            element: <HelpCenterFormPage />,
            handle: { title: "编辑常见问题", permissions: ["ROLE_SS_HELP_R", "ROLE_SS_HELP_W"] }
        },
        {
            path: "lianYunAbout/userAgreement",
            element: <LianYunArticlePage articleType={2} />,
            handle: { title: "用户协议", permissions: ["ROLE_SS_ABOUT"] }
        },
        {
            path: "lianYunAbout/privacyAgreement",
            element: <LianYunArticlePage articleType={3} />,
            handle: { title: "隐私政策", permissions: ["ROLE_SS_ABOUT"] }
        },
        {
            path: "lianYunAbout/memberAgreement",
            element: <LianYunArticlePage articleType={4} />,
            handle: { title: "会员服务协议", permissions: ["ROLE_SS_ABOUT"] }
        },
        {
            path: "lianYunAbout/deviceClaimAgreement",
            element: <LianYunArticlePage articleType={5} />,
            handle: { title: "设备申领协议", permissions: ["ROLE_SS_ABOUT"] }
        },
        {
            path: "lianYunAbout/oilingAgreement",
            element: <LianYunArticlePage articleType={10} />,
            handle: { title: "加油协议", permissions: ["ROLE_SS_ABOUT"] }
        },
        {
            path: "lianYunAbout/shippingContractServiceAgreement",
            element: <LianYunArticlePage articleType={11} />,
            handle: { title: "船运合同服务协议", permissions: ["ROLE_SS_ABOUT"] }
        },
        {
            path: "lianYunAbout/aiPrivacyAgreement",
            element: <LianYunArticlePage articleType={9} />,
            handle: { title: "AI保护规则", permissions: ["ROLE_SS_ABOUT"] }
        },
        {
            path: "lianYunAbout/aiUserAgreement",
            element: <LianYunArticlePage articleType={8} />,
            handle: { title: "AI用户协议", permissions: ["ROLE_SS_ABOUT"] }
        }
    ]
};

export default userOperationRoutes;
